export var transformMenuBlockData = function transformMenuBlockData(userMenu, id) {
  var findedBlock = userMenu.blocks.find(function (menuBlock) {
    return menuBlock.id === id;
  });
  return findedBlock;
};